export function validateBoolean(value: unknown, errorMessage: string) {
  return value === true || value === false ? true : errorMessage;
}
